import React, { useCallback, useEffect, useRef, useState } from 'react';
import { Row, Col } from "react-bootstrap"
import { useTranslation } from "react-i18next";
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { useBoolean } from '@fluentui/react-hooks';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import moment from 'moment';
import { Calendar } from 'react-calendar';
import { useManipulateCalendarType } from '../../../../../../hooks/component/sKPI/useOfSidePanelAddDataserieVariableValue';
import CLabel from '../../../../../Common/CLabel';
import { Dropdown, SpinnerSize, TagPicker } from '@fluentui/react';
import { __HoursValues, __KPIPeriods, __MessageTypes, __ShiftValues, enum__FormulaId, enum__PRIVILEGES } from '../../../../../../common/Dictionaries';
import CCurrencyTextBox from '../../../../../Common/CCurrencyTextBox';
import { __OBJECT_STRUCTURE_BoardFilters, __OBJECT_STRUCTURE_GetDataserieValue } from '../../../../../../common/ObjectStructures/sKPI';
import { addDataSerieValue, editDataSerieValue } from '../../../../../../services/sKPI/dataserie.service';
import { _global_buttonStyles } from '../../../../../../common/ObjectStructures/Trasnversal';
import { useContext } from 'react';
import MainAppContext from '../../../../../../MainAppContext';
import MessageBoxInfoComplex from '../../../../../Common/Message/MessageBoxInfoComplex';
import { isNullOrEmpty, isNullUndefined, isNullUndefinedOrEmpty, showMessage } from '../../../../../../common/Helpers';
import MessageBox from '../../../../../Common/Message/MessageBox';
import PropTypes from 'prop-types';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../../../common/CommonFuctions';
import ListPagination from '../../../../../Templates/List/ListPagination';
import { useGetDataSerieValue } from '../../../../../../hooks/services/sKPI/useOfDataSerie';
import DataserieValueDocumentBox from './DataserieValueDocumentBox';
import { action_setBoardContractFilterComponents_And_Sync_Flag, action_setPageState } from '../../../../../../reducers/actions/KPI/actions';
import { useDispatch, useSelector } from 'react-redux';
import BoardAppContext from '../../../../../../BoardAppContext';
import { _checkSecurityUser, _checkSecurityUser_And_ResponsibleInsert, _checkSecurityUserAux } from '../../../../../../common/Helpers/HLP_Security';
import { useGetContractByElementId, useGetContractById } from '../../../../../../hooks/services/sBook/useOfContract';
import CValidator from '../../../../../Common/CValidator';
import { cloneDeep } from 'lodash-es';
import Loading from '../../../../../Templates/Site/Loading';

const SidePanelAddDataserieVariableValue = (props) => {
    const { t } = useTranslation();
    const contextSite = useContext(MainAppContext);
    const contextBoard = useContext(BoardAppContext);
    const dispatch = useDispatch();
    
    const { 
        inputParam_ElementId = null,
        inputParam_BoardId=null,
        inputParam_IsPanelOpen = null,
        inputParam_SetterIsPanelOpen = null,
        inputParam_DataSerie = null,
        inputParam_ElementType = null,
        inputParam_SetCalendarType = null,
        inputParam_UserProps = null,
    } = props;

    const { _boardContractFilterOfComponents: boardContractFilterOfComponents } = useSelector((state) => state.boardViewComponentsScope);

    const hourList = __HoursValues.map(item => ({ key: item.key, name: item.value }));
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    const [messageConfig, setMessageConfig] = useState({
        message : null,
        messageType : "",
        showMessage : false,
    });
    const [isValidForm, setIsValidForm] = useState({
        v1: true,
        v2: true,
        valueReal: true,
        valueProvisory: true,
        valueBudget: true,
        valueForecast: true,
    });

    const { _boardElementRoles: boardElementRoles } = useSelector((state) => state.boardViewComponentsScope);
    const { _systemRoles: systemRoles } = useSelector((state) => state.boardViewComponentsScope);

    const [fireGetEditElement, setFireGetEditElement] = useState({fire : false, dataserieValueId: null, serieTime: null});  
    const initialCalendarSearchDone = useRef(false);
    const [serieTimeIsSelected, setSerieTimeIsSelected] = useState(false);  

    const [objDataserieValue, setObjDataserieValue] = useState(__OBJECT_STRUCTURE_GetDataserieValue(inputParam_DataSerie.dataserieId))
    useGetDataSerieValue(objDataserieValue, setObjDataserieValue, inputParam_DataSerie.dataserieId, fireGetEditElement.dataserieValueId, fireGetEditElement.serieTime, inputParam_IsPanelOpen, fireGetEditElement.fire, setFireGetEditElement)

    const [objContract, setObjContrat] = useState(null)
    useGetContractByElementId(inputParam_ElementId, objContract, setObjContrat, inputParam_BoardId, boardContractFilterOfComponents, contextSite.kpiModule.boardCalendarFilterConfig)

    const aux_userProps = !isNullUndefined(inputParam_UserProps) ? inputParam_UserProps : contextBoard.userPropsKpi.value;

    const _priv_canAddDataserieValue = _checkSecurityUserAux(contextSite.onlyObserver, aux_userProps, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.KPI_CONTRACT_CREATE, boardElementRoles, systemRoles);
    const _priv_canAddAmountValues = _checkSecurityUser_And_ResponsibleInsert(inputParam_DataSerie.responsibleInsertRole, contextSite.onlyObserver, aux_userProps, contextSite.securityProps, inputParam_DataSerie.elementId, enum__PRIVILEGES.KPI_CONTRACT_CREATE, boardElementRoles, systemRoles);

    const [itemAdding, setItemAdding] = useState(false);
    const [itemEditing, setItemEditing] = useState(false);
    const [actionExecuting, setActionExecuting] = useState(false);
    
    const [clearSelection, setClearSelection] = useState(false);
    const [documentLinkList, setDocumentLinkList] = useState(null);



    const handleSelect = (value) => {
        setItemAdding(false)
        setClearSelection(false);
        setSerieTimeIsSelected(true);

        setObjDataserieValue(prevState => ({
            ...prevState,               
            id: null,  
            serieTime : value,
        }));
    }

    const triggerGetEditElementByCalendarValue = useCallback((value) => {
        if (isNullUndefined(value)) {
            return;
        }

        let date = moment(value);
        date.startOf('day');
        date.set('hour', objDataserieValue.wildcard !== null ? objDataserieValue.wildcard : 0);

        setItemAdding(false);
        setItemEditing(false);

        setFireGetEditElement(prevState => ({
            ...prevState,
            fire: true,
            serieTime: date.toDate(),
        }));

        setClearSelection(false);
        setSerieTimeIsSelected(true);
    }, [objDataserieValue.wildcard]);


    const [calendarConfig, setCalendarConfig] = useState({
        maxDetail:null,//decade, year, month
        minDetail:"century",
        selectRange:false,
        showDoubleView:false,
        onChange:handleSelect,
        returnValue:"start"
    });
    useManipulateCalendarType(calendarConfig, setCalendarConfig, inputParam_ElementType, inputParam_IsPanelOpen, inputParam_DataSerie.measurementPeriodId, setObjDataserieValue)

    useEffect(() => {
        if (!inputParam_IsPanelOpen) {
            initialCalendarSearchDone.current = false;
            return;
        }

        if (
            calendarConfig.maxDetail !== null &&
            objDataserieValue.serieTime !== null &&
            !initialCalendarSearchDone.current
        ) {
            initialCalendarSearchDone.current = true;
            triggerGetEditElementByCalendarValue(objDataserieValue.serieTime);
        }
    }, [inputParam_IsPanelOpen, calendarConfig.maxDetail, objDataserieValue.serieTime, triggerGetEditElementByCalendarValue]);

    const validateForm = () => {
        let isValid =(
            objDataserieValue.dataserieId !== null  &&
            objDataserieValue.serieTime !== null  &&
            objDataserieValue.locked !== null
        ) ? true : false;

        let isValidV12 = true;

        if (inputParam_DataSerie.useOfVariables) {
            isValidForm.v1 = !isNullUndefinedOrEmpty(objDataserieValue.v1)

            if (inputParam_DataSerie.formulaId !== enum__FormulaId.SIMPLE) {
                isValidForm.v2 = !isNullUndefinedOrEmpty(objDataserieValue.v2)
            }
            else {
                isValidForm.v2 = true;
            }

            isValidForm.valueReal = true
            isValidForm.valueProvisory = true
            isValidForm.valueBudget = true
            isValidForm.valueForecast = true

            isValidV12 =   (
                (inputParam_DataSerie.formulaId !== enum__FormulaId.SIMPLE ?
                    ((isValidForm.v1 && isValidForm.v2)) : isValidForm.v1
                )
            );

            if (inputParam_DataSerie.formulaId !== enum__FormulaId.SIMPLE) {
                if (isNullUndefinedOrEmpty(objDataserieValue.v1) && isNullUndefinedOrEmpty(objDataserieValue.v2)) {
                    showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-managevariables-requireddata-wvariables'))
                }
                else {
                    if (isNullUndefinedOrEmpty(objDataserieValue.v1) && !isNullUndefinedOrEmpty(objDataserieValue.v2)) {
                        isValid = false;
                        isValidForm.v1 = false;
                    }
                    if (isNullUndefinedOrEmpty(objDataserieValue.v2) && !isNullUndefinedOrEmpty(objDataserieValue.v1)) {
                        isValid = false;
                        isValidForm.v2 = false;
                    }
    
                    if (!isValidV12) {
                        showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-managevariables-requireddata-wvariables'))
                    }
                }
            }
            else {
                if (isNullUndefinedOrEmpty(objDataserieValue.v1)) {
                    if (!isValidV12) {
                        showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-managevariables-requireddata-wvariable'))
                    }
                }
                else {
                    if (!isValid) {
                        showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-managevariables-requireddata'))
                    }
                }
            }
        }
        else {
            isValidForm.valueReal = !isNullUndefinedOrEmpty(objDataserieValue.valueReal)
            isValidForm.valueProvisory = !isNullUndefinedOrEmpty(objDataserieValue.valueProvisory)
            isValidForm.valueBudget = !isNullUndefinedOrEmpty(objDataserieValue.valueBudget)
            isValidForm.valueForecast = !isNullUndefinedOrEmpty(objDataserieValue.valueForecast)
            isValid = (isValidForm.valueReal || isValidForm.valueProvisory || isValidForm.valueBudget || isValidForm.valueForecast);

            if (isValid) {
                isValidForm.valueReal = isValid
                isValidForm.valueProvisory = isValid
                isValidForm.valueBudget = isValid
                isValidForm.valueForecast = isValid
            }

            if (!isValid) {
                showMessage(setMessageConfig, true, __MessageTypes.WARNING, t('data-lang-msg-managevariables-requireddata'))
            }
        }

        setIsValidForm(isValidForm)

        return isValid && isValidV12
    };

    const onClickMonth = (value) => {
        triggerGetEditElementByCalendarValue(value);
    }

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        showMessage(setMessageConfig, false, null, null)
        initialCalendarSearchDone.current = false;
        setDocumentLinkList(null);
        setItemAdding(false)
        setItemEditing(false)

        setIsValidForm({
            v1: true,
            v2: true,
            valueReal: true,
            valueProvisory: true,
            valueBudget: true,
            valueForecast: true,
        });
        setObjDataserieValue(__OBJECT_STRUCTURE_GetDataserieValue(null));
        setClearSelection(true);
        setSerieTimeIsSelected(false);
        setCalendarConfig(prevState => ({
            ...prevState,
            maxDetail:null,//decade, year, month
        })) 
        inputParam_SetCalendarType && inputParam_SetCalendarType(null)
    };

    const onAddItem = async () => {
        setActionExecuting(true)
        setItemAdding(true)
        let newobj = null

        objDataserieValue.id = 0;
        objDataserieValue.dataserieId = inputParam_DataSerie.dataserieId;

        objDataserieValue.v1 = !isNullUndefinedOrEmpty(objDataserieValue.v1) ? parseFloat(objDataserieValue.v1.toString().replace(',','.')) : objDataserieValue.v1
        objDataserieValue.v2 = !isNullUndefinedOrEmpty(objDataserieValue.v2) ? parseFloat(objDataserieValue.v2.toString().replace(',','.')) : objDataserieValue.v2
        objDataserieValue.valueReal = !isNullUndefinedOrEmpty(objDataserieValue.valueReal) ? parseFloat(objDataserieValue.valueReal.toString().replace(',','.')) : objDataserieValue.valueReal
        objDataserieValue.valueProvisory = !isNullUndefinedOrEmpty(objDataserieValue.valueProvisory) ? parseFloat(objDataserieValue.valueProvisory.toString().replace(',','.')) : objDataserieValue.valueProvisory
        objDataserieValue.valueBudget = !isNullUndefinedOrEmpty(objDataserieValue.valueBudget) ? parseFloat(objDataserieValue.valueBudget.toString().replace(',','.')) : objDataserieValue.valueBudget
        objDataserieValue.valueForecast = !isNullUndefinedOrEmpty(objDataserieValue.valueForecast) ? parseFloat(objDataserieValue.valueForecast.toString().replace(',','.')) : objDataserieValue.valueForecast
        objDataserieValue.valueGoal = !isNullUndefinedOrEmpty(objDataserieValue.valueGoal) ? parseFloat(objDataserieValue.valueGoal.toString().replace(',','.')) : objDataserieValue.valueGoal

        newobj = {...objDataserieValue};
        const aux_wildcard = newobj.wildcard === null ? hourList.find(x => x.key === (new Date().getHours() * 100)).key : newobj.wildcard

        const aux_objeDataserieValue = {...objDataserieValue}
        let currentSerieTime = null;
        try {
            currentSerieTime = moment(aux_objeDataserieValue.serieTime).format('YYYYMMDDHHmmss');
        } catch (error) {
            currentSerieTime = aux_objeDataserieValue.serieTime
        }

        if (inputParam_ElementType === "hour") {
            const aux_valueWildcard = aux_wildcard.toString();
            const longitud = aux_valueWildcard.length;
            let hora, minutos;
            
            if (longitud === 3) {
              hora = aux_valueWildcard.substring(0, 1);
              minutos = aux_valueWildcard.substring(1);
            } else if (longitud === 4) {
              hora = aux_valueWildcard.substring(0, 2);
              minutos = aux_valueWildcard.substring(2);
            }

            newobj.serieTime = moment(objDataserieValue.serieTime.setHours(hora, minutos , 0, 0)).format('YYYYMMDDHHmmss');
        }
        else {
            if (inputParam_ElementType === "shift") {
                newobj.serieTime = moment(objDataserieValue.serieTime.setHours(0, newobj.wildcard, 0, 0)).format('YYYYMMDDHHmmss');
            }
            else {
                newobj.serieTime = moment(objDataserieValue.serieTime, 'YYYYMMDDHHmmss').format('YYYYMMDDHHmmss');
            }
        }

        if (validateForm() && serieTimeIsSelected === true) {  
            console.log();
            
            let startDate = null;
            try {
                startDate = inputParam_DataSerie.beginDate === null ? inputParam_DataSerie.beginDate : moment(inputParam_DataSerie.beginDate.indexOf('T') !== -1 ? inputParam_DataSerie.beginDate.split('T')[0] : inputParam_DataSerie.beginDate);
            } catch (error) {
                startDate = inputParam_DataSerie.beginDate === null ? inputParam_DataSerie.beginDate : moment(inputParam_DataSerie.beginDate);
            }

            console.log();

            let endDate = null;
            try {
                endDate = inputParam_DataSerie.endDate === null ? inputParam_DataSerie.endDate : moment(inputParam_DataSerie.endDate.indexOf('T') !== -1 ? inputParam_DataSerie.endDate.split('T')[0] : inputParam_DataSerie.endDate);
            } catch (error) {
                endDate = inputParam_DataSerie.endDate === null ? inputParam_DataSerie.endDate : moment(inputParam_DataSerie.endDate);
            }
            
            console.log();
            if (startDate === null) { if (objContract.startDate !== null) { startDate = moment(objContract.startDate.indexOf('T') !== -1 ? objContract.startDate.split('T')[0] : objContract.startDate) } }
            console.log();
            if (endDate === null) { if (objContract.endDate !== null) { endDate = moment(objContract.endDate.indexOf('T') !== -1 ? objContract.endDate.split('T')[0] : objContract.endDate) } }
            
            console.log();
            let value = false;
    
            if (startDate === null && endDate === null) {
                console.log();
                value = true;
            }
            else {
                console.log();
                if (startDate !== null && endDate === null) {
                    console.log();
                    const aux_startDate = startDate.format('YYYYMMDD000000')
                    if (currentSerieTime >= aux_startDate) {
                        console.log();
                        value = true;
                    }
                    else {
                        console.log();
                        value = false;
                    }
                    console.log();
                }
                else {
                    console.log();
                    if (startDate === null && endDate !== null) {
                        console.log();
                        const aux_endDate = endDate.format('YYYYMMDD000000')
                        if (currentSerieTime <= aux_endDate) {
                            console.log();
                            value = true;
                            console.log();
                        }
                        else {
                            console.log();
                            value = false;
                            console.log();
                        }
                        console.log();
                    }
                    else {
                        console.log();
                        if (startDate !== null && endDate !== null) {
                            console.log();
                            const aux_startDate = startDate.format('YYYYMMDD000000')
                            const aux_endDate = endDate.format('YYYYMMDD000000')
                            console.log();
                            if (currentSerieTime <= aux_endDate && currentSerieTime >= aux_startDate) {
                                console.log();
                                value = true;
                                console.log();
                            }
                            else {
                                console.log();
                                value = false;
                                console.log();
                            }
                            console.log();
                        }
                        else {
                            console.log();
                            value = false;
                            console.log();
                        }
                    }
                }
            }
            
            if (value) {
                console.log();
                await addDataSerieValue(newobj).then((response) => {
                    if (response.data.succeeded) {
                        aux_objeDataserieValue.id = response.data.data;
                        setObjDataserieValue(aux_objeDataserieValue);
                        showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                        //setClearSelection(true);
                        //setSerieTimeIsSelected(false);
                    }
                    else {
                        let message = response.data.message.split('#')[0];
                        let period = response.data.message.split('#')[1].replace('.', '');
                        let correctPeriodWord = t(__KPIPeriods.find(x => x.apiType === period).text).toLowerCase()

                        showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(message).replace('{0}', correctPeriodWord))
                    }
                    setItemAdding(false)
                    setActionExecuting(false)
                }).catch(() => {
                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
                    setItemAdding(false)
                    setActionExecuting(false)
                });
            }
            else {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-valueoutofkpidate'))
                setItemAdding(false)
                setActionExecuting(false)
            }
        }
        else {
            setItemAdding(false)
            setActionExecuting(false)

            if (serieTimeIsSelected === false) {
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-requireddatanotset'))
            }
        }
    };

    const onEditItem = async () => {
        setActionExecuting(true)
        setItemEditing(true)

        let newobj = null

        objDataserieValue.v1 = !isNullOrEmpty(objDataserieValue.v1) ? parseFloat(objDataserieValue.v1.toString().replace(',','.')) : objDataserieValue.v1
        objDataserieValue.v2 = !isNullOrEmpty(objDataserieValue.v2) ? parseFloat(objDataserieValue.v2.toString().replace(',','.')) : objDataserieValue.v2
        objDataserieValue.valueReal = !isNullOrEmpty(objDataserieValue.valueReal) ? parseFloat(objDataserieValue.valueReal.toString().replace(',','.')) : objDataserieValue.valueReal
        objDataserieValue.valueProvisory = !isNullOrEmpty(objDataserieValue.valueProvisory) ? parseFloat(objDataserieValue.valueProvisory.toString().replace(',','.')) : objDataserieValue.valueProvisory
        objDataserieValue.valueBudget = !isNullOrEmpty(objDataserieValue.valueBudget) ? parseFloat(objDataserieValue.valueBudget.toString().replace(',','.')) : objDataserieValue.valueBudget
        objDataserieValue.valueForecast = !isNullOrEmpty(objDataserieValue.valueForecast) ? parseFloat(objDataserieValue.valueForecast.toString().replace(',','.')) : objDataserieValue.valueForecast
        objDataserieValue.valueGoal = !isNullOrEmpty(objDataserieValue.valueGoal) ? parseFloat(objDataserieValue.valueGoal.toString().replace(',','.')) : objDataserieValue.valueGoal

        newobj = cloneDeep(objDataserieValue);
        newobj.wildcard = newobj.wildcard === null ? null : (inputParam_ElementType === "hour" ? new Date().getHours() : newobj.wildcard);
        newobj.serieTime = moment(objDataserieValue.serieTime.setHours(0, newobj.wildcard, 0, 0)).format('YYYYMMDDHHmmss');

        if (validateForm()) {    
            await editDataSerieValue(newobj).then((response) => {
                if (response.data.succeeded) {
                    //setObjDataserieValue(__OBJECT_STRUCTURE_GetDataserieValue(inputParam_DataSerie.dataserieId));
                    showMessage(setMessageConfig, true, __MessageTypes.SUCCESS, t('data-lang-msg-operationperformed'))
                    //setClearSelection(true);
                    //setSerieTimeIsSelected(false);
                }
                else {
                    let message = response.data.message.split('#')[0];
                    let period = response.data.message.split('#')[1].replace('.', '');
                    let correctPeriodWord = t(__KPIPeriods.find(x => x.apiType === period).text).toLowerCase()

                    showMessage(setMessageConfig, true, __MessageTypes.ERROR, t(message).replace('{0}', correctPeriodWord))
                }

                setItemAdding(false)
                setItemEditing(false)
                setActionExecuting(false)
            }).catch(() => {
                setItemEditing(false)
                setActionExecuting(false)
                showMessage(setMessageConfig, true, __MessageTypes.ERROR, t('data-lang-msg-operationerror'))
            });
        }
        else {
            setItemEditing(false)
            setActionExecuting(false)
        }
    };

    const onSelectionHourChange = (selectedValues) => {
        let aux_value =  selectedValues.length > 0 ? selectedValues[0].key : null;

        objDataserieValue.serieTime = new Date(new Date(objDataserieValue.serieTime).setHours(aux_value/100))

        setItemAdding(false)
        setItemEditing(false)
        setClearSelection(false);
        setSerieTimeIsSelected(true);

        setFireGetEditElement(prevState => ({
            ...prevState,
            fire: true,
            serieTime: objDataserieValue.serieTime,
        }));

        setObjDataserieValue(prevState => ({
            ...prevState,  
            id: null,
            serieTime: objDataserieValue.serieTime,
            wildcard : aux_value,
        }));
    };

    const onShiftChange = (control, option) => {
        let aux_value =  option.key;
        
        objDataserieValue.serieTime = new Date(new Date(objDataserieValue.serieTime).setHours(0, aux_value, 0, 0))

        setItemAdding(false)
        setItemEditing(false)
        setClearSelection(false);
        setSerieTimeIsSelected(true);

        setFireGetEditElement(prevState => ({
            ...prevState,
            fire: true,
            serieTime: objDataserieValue.serieTime,
        }));

        setObjDataserieValue(prevState => ({
            ...prevState, 
            id: null,
            serieTime: objDataserieValue.serieTime,
            wildcard : aux_value,
        }));
    };

    const onHideDialogAndPanel = () => {
        onClosePanel();
        hideDialog();
    };
    
    const onClosePanel = () => {
        contextSite.kpiModule.boardCalendarFilterConfig.setter(prevState => ({
            ...prevState,
            fireFilter: true
        }))

        dispatch(action_setPageState(false));
        dispatch(action_setBoardContractFilterComponents_And_Sync_Flag(__OBJECT_STRUCTURE_BoardFilters(), false));

        onDismissPanel();

        inputParam_SetterIsPanelOpen(false);
    };

    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12} className="message-verybottom-panel-medium-pagination">
                        <ListPagination
                            listLocalStoragePageSizeVariableName="addDataserieValue"
                            data={ documentLinkList }
                            setData={ setDocumentLinkList } />
                    </Col>
                    <Col>
                        <MessageBoxInfoComplex
                            inputParam_Width="100%"
                            inputParam_Message={`
                                ${t('data-lang-msg-adddataserievaluehierarchy')}:  
                                <b>1) ${t('data-lang-lbl-field-valueReal')},  
                                2) ${t('data-lang-lbl-field-valueProvisory')},  
                                3) ${t('data-lang-lbl-field-valueBudget')},  
                                4) ${t('data-lang-lbl-field-valueForecast')}.</b>
                            `}
                        />
                        {
                            inputParam_DataSerie.useOfVariables &&
                            <MessageBoxInfoComplex inputParam_Width="100%" inputParam_Message={`${t('data-lang-msg-adddataserievalueformulavalue')} (${t('data-lang-lbl-field-valueReal')}).`} />
                        }
                        {
                            !(_priv_canAddDataserieValue.value || _priv_canAddAmountValues.value) &&
                            <MessageBoxInfoComplex inputParam_Width="100%" inputParam_Message={`${t('data-lang-msg-locked')}.`} />
                        }
                    </Col>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <MessageBox
                            inputParam_Message={ messageConfig.message }
                            inputParam_Display={ messageConfig.showMessage }
                            inputParam_MessageType={ messageConfig.messageType }
                            inputParam_SetterMessage={ setMessageConfig }
                        />
                    </Col>
                    <Col xl={12}>
                        {
                            (objDataserieValue.id === null || objDataserieValue.id === 0) && (_priv_canAddDataserieValue.value || _priv_canAddAmountValues.value) && !itemAdding && !actionExecuting &&
                            <PrimaryButton onClick={ onAddItem } styles={_global_buttonStyles}>{ t('data-lang-btn-add') }</PrimaryButton>
                        }
                        {
                            (objDataserieValue.id !== null && objDataserieValue.id !== 0) && (_priv_canAddDataserieValue.value || _priv_canAddAmountValues.value) && !itemEditing && !actionExecuting &&
                            <PrimaryButton onClick={ onEditItem } styles={_global_buttonStyles}>{ t('data-lang-btn-edit') }</PrimaryButton>
                        }
                        {
                            !actionExecuting &&
                            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                        }
                        {
                            actionExecuting &&
                            <Loading
                                inputParam_Style={{marginTop: 0}}
                                inputParam_ShowLoading={true}
                                inputParam_ShowText={true}
                                inputParam_Text={t('data-lang-lbl-executing')}
                                inputParam_Position="unset"
                                inputParam_Width="20px"
                                inputParam_Height="20px"
                                inputParam_Vertical={false}
                                inputParam_ColClassName="my-auto"
                                inputParam_EjecutingTextClass={"ps-4"}
                                inputParam_Left="87%"
                                inputParam_Top="11px"
                                inputParam_RootClass="pe-4 loading-buttonSize-font-size"
                            />
                        }
                    </Col>
                </Row>
    }

    const listContainsTagList = (tag, tagList) => {
        if (!tagList || !tagList.length || tagList.length === 0) {
            return false;
        }
        return tagList.some(compareTag => compareTag.key === tag.key);
    };

    const filterSuggestedHour = (filterText, tagList) => {
        return filterText
            ? hourList.filter(
                tag => tag.name.toLowerCase().indexOf(filterText.toLowerCase()) === 0 && !listContainsTagList(tag, tagList),
            )
        : [];
    };

    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onClosePanel }
                headerText={ t('data-lang-boxname-adddataserievalue') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ PanelType.medium }
                type={ PanelType.medium }
            >
                <Row className="pt-3">
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-variablename') } labelValue={ `${inputParam_DataSerie.variableName} (${inputParam_DataSerie.um})` } />
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col>
                        <CLabel aditionalStyles={{display: "contents"}} labelText={ t('data-lang-lbl-period') } labelValue={ t(__KPIPeriods.find(x => x.key === inputParam_DataSerie.measurementPeriodId).text) }  />
                    </Col>
                </Row>
                <Row className="pt-3">
                    <Col className='col-auto mx-auto'>
                        {
                            calendarConfig.maxDetail &&
                            <Calendar
                                className={`${clearSelection ? 'clear-calendar-date-selection' : ''} disabledbutton mx-auto`}
                                onChange={onClickMonth}
                                returnValue={calendarConfig.returnValue}
                                value={objDataserieValue.serieTime !== null ? new Date(objDataserieValue.serieTime) : (calendarConfig.selectRange === false ? undefined : [undefined, undefined])}
                                selectRange={calendarConfig.selectRange}
                                showNeighboringMonth={false}
                                maxDate={new Date()}
                                minDetail={calendarConfig.minDetail}
                                maxDetail={calendarConfig.maxDetail}
                                showDoubleView={calendarConfig.showDoubleView}
                                formatLongDate={(locale, date) => moment(date).format("DD/MM/YYYY")}
                                locale={"es-ES"}
                            />
                        }
                        {
                            serieTimeIsSelected === false &&
                            <CValidator inValidText={ t('data-lang-msg-required') } isInValid={ serieTimeIsSelected === false } />
                        }
                    </Col>
                </Row>
                <Row className="pt-3"> 
                    {
                        inputParam_DataSerie.measurementPeriodId === 5 &&
                        <Col xl={6}>
                            <Dropdown
                                placeholder="Turno"
                                label="Turno"
                                options={__ShiftValues}
                                styles={{ width: 50 }}
                                onChange={onShiftChange}
                                selectedKey={objDataserieValue.wildcard !== null ? objDataserieValue.wildcard : 1}
                            />
                        </Col>
                    }
                    {
                        inputParam_DataSerie.measurementPeriodId === 4 &&
                        <Col xl={6}>
                            <label className='ms-Label custom-txt-root'>{t('data-lang-lbl-hour')}</label>
                            <TagPicker
                                removeButtonAriaLabel="Remove"
                                selectionAriaLabel={t('data-lang-lbl-selectedhour')}
                                onResolveSuggestions={filterSuggestedHour}
                                getTextFromItem={(item) => item.name}
                                pickerSuggestionsProps={{
                                    suggestionsHeaderText: t('data-lang-lbl-suggestedhour'),
                                    noResultsFoundText: t('data-lang-lbl-hournotfound'),
                                }}
                                itemLimit={1}
                                defaultSelectedItems={objDataserieValue.wildcard !== null ? [hourList.find(x => x.key === objDataserieValue.wildcard)] : [hourList.find(x => x.key === (new Date().getHours() * 100))]}
                                onChange={onSelectionHourChange}
                                pickerCalloutProps={{ doNotLayer: true }}
                            />
                        </Col>
                    }
                </Row>
                {
                    inputParam_DataSerie.useOfVariables &&
                    <Row className="py-2 mt-3 border rounded-1">
                        <Col xl={12}>
                            <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-formula')} labelValue={objDataserieValue.formulaDesc}  />
                        </Col>
                        <Col xl={6}>
                            <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-k1')} labelValue={objDataserieValue.k1}  />
                        </Col>
                        <Col xl={6}>
                            <CLabel aditionalStyles={{display: "contents"}} labelText={t('data-lang-lbl-field-k2')} labelValue={objDataserieValue.k2}  />
                        </Col>
                        <Col xl={6}>
                            <CCurrencyTextBox
                                labelText={`${t('data-lang-lbl-field-v1')} - ${!isNullUndefinedOrEmpty(inputParam_DataSerie.v1Name) ? inputParam_DataSerie.v1Name : '' }`}
                                controlValue={objDataserieValue.v1}
                                objectPropertyNameForSetter={"v1"}
                                setterIsPropertyObject={true}
                                isInvalidControl={ !isValidForm.v1 }
                                setterControlValue={setObjDataserieValue}
                                object={objDataserieValue}
                                disabled={!(_priv_canAddDataserieValue.value || _priv_canAddAmountValues.value)}
                            />
                        </Col>
                        <Col xl={6}>
                        {
                            inputParam_DataSerie.formulaId !== enum__FormulaId.SIMPLE &&
                            <CCurrencyTextBox
                                labelText={`${t('data-lang-lbl-field-v2')} - ${!isNullUndefinedOrEmpty(inputParam_DataSerie.v2Name) ? inputParam_DataSerie.v2Name : '' }`}
                                controlValue={objDataserieValue.v2}
                                objectPropertyNameForSetter={"v2"}
                                setterIsPropertyObject={true}
                                isInvalidControl={ !isValidForm.v2 }
                                setterControlValue={setObjDataserieValue}
                                object={objDataserieValue}
                                disabled={!(_priv_canAddDataserieValue.value || _priv_canAddAmountValues.value)}
                            />
                        }
                        </Col>
                    </Row>
                }
                
                
                
                <Row className="py-2">
                    <Col xl="6">
                        <CCurrencyTextBox
                            labelText={t('data-lang-lbl-field-valueReal')}
                            controlValue={objDataserieValue.valueReal}
                            objectPropertyNameForSetter={"valueReal"}
                            setterIsPropertyObject={true}
                            isInvalidControl={ false }
                            setterControlValue={setObjDataserieValue}
                            object={objDataserieValue}
                            invalidText=""
                            disabled={(!_priv_canAddDataserieValue.value)}
                            />
                    </Col>
                    <Col xl="6">
                        <CCurrencyTextBox
                            labelText={t('data-lang-lbl-field-valueProvisory')}
                            controlValue={objDataserieValue.valueProvisory}
                            objectPropertyNameForSetter={"valueProvisory"}
                            setterIsPropertyObject={true}
                            isInvalidControl={ false }
                            setterControlValue={setObjDataserieValue}
                            object={objDataserieValue}
                            invalidText=""
                            disabled={(!_priv_canAddDataserieValue.value)}
                            />
                    </Col>
                    <Col xl="6">
                        <CCurrencyTextBox
                            labelText={t('data-lang-lbl-field-valueBudget')}
                            controlValue={objDataserieValue.valueBudget}
                            objectPropertyNameForSetter={"valueBudget"}
                            setterIsPropertyObject={true}
                            isInvalidControl={ false }
                            setterControlValue={setObjDataserieValue}
                            object={objDataserieValue}
                            invalidText=""
                            disabled={(!_priv_canAddDataserieValue.value)}
                            />
                    </Col>
                    <Col xl="6">
                        <CCurrencyTextBox
                            labelText={t('data-lang-lbl-field-valueForecast')}
                            controlValue={objDataserieValue.valueForecast}
                            objectPropertyNameForSetter={"valueForecast"}
                            setterIsPropertyObject={true}
                            isInvalidControl={ false }
                            setterControlValue={setObjDataserieValue}
                            object={objDataserieValue}
                            invalidText=""
                            disabled={(!_priv_canAddDataserieValue.value)}
                            />
                    </Col>
                    <Col xl="6">
                        <CCurrencyTextBox
                            labelText={t('data-lang-lbl-field-valueGoal')}
                            controlValue={objDataserieValue.valueGoal}
                            objectPropertyNameForSetter={"valueGoal"}
                            setterIsPropertyObject={true}
                            isInvalidControl={ false }
                            setterControlValue={setObjDataserieValue}
                            object={objDataserieValue}
                            invalidText=""
                            disabled={(!_priv_canAddDataserieValue.value)}
                            />
                    </Col>
                    
                    {
                        objDataserieValue.id !== 0 && objDataserieValue.id !== null &&
                        <Col xl="6">
                            <CCurrencyTextBox
                                labelText={t('data-lang-lbl-field-valueGoalPercent')}
                                controlValue={objDataserieValue.valueGoalPercent}
                                objectPropertyNameForSetter={"valueGoalPercent"}
                                setterIsPropertyObject={true}
                                isInvalidControl={ false }
                                disabled={true}
                                setterControlValue={setObjDataserieValue}
                            />
                        </Col>
                    }
                </Row>
                {
                    objDataserieValue.id !== null && objDataserieValue.id !== 0 &&
                    <DataserieValueDocumentBox
                        inputParam_IsPanelOpen={inputParam_IsPanelOpen}
                        inputParam_ObjDataserieValueId={objDataserieValue.id}
                        inputParam_SetMessageConfig={setMessageConfig}
                        inputParam_EditMode={(_priv_canAddDataserieValue.value || _priv_canAddAmountValues.value)}    
                        inputParam_DocumentLinkList={documentLinkList}
                        inputParam_SetDocumentLinkList={setDocumentLinkList}
                    />
                }
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
};

SidePanelAddDataserieVariableValue.propTypes = {
    inputParam_IsPanelOpen: PropTypes.bool.isRequired,
    inputParam_SetterIsPanelOpen: PropTypes.func.isRequired,
    inputParam_DataSerie: PropTypes.object.isRequired,
    inputParam_ElementType: PropTypes.string.isRequired,
    inputParam_SetCalendarType: PropTypes.func.isRequired,
};

export default SidePanelAddDataserieVariableValue;